import React, { useEffect } from 'react';
import { Redirect, Route } from 'react-router-dom';
import {
  IonApp,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
} from '@ionic/react';
import { ChakraProvider } from '@chakra-ui/react';
import { IonReactRouter } from '@ionic/react-router';
import { ellipse, square, triangle } from 'ionicons/icons';

import { QueryClient, QueryClientProvider } from 'react-query';

import EpisodeTab from './pages/EpisodeTab';
import Tab2 from './pages/Tab2';
import Tab3 from './pages/Tab3';
/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';
import 'rsuite/dist/styles/rsuite-default.css';
import 'swiper/swiper.min.css';
import 'swiper/modules/pagination/pagination.min.css';
import 'swiper/modules/navigation/navigation.min.css';

/* Theme variables */
import './theme/variables.css';
import { GlobalStyles, RealGlobalStyles, chakraTheme } from './theme/global';

const queryClient = new QueryClient();

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ChakraProvider theme={chakraTheme} resetCSS={false}>
        <GlobalStyles>
          <RealGlobalStyles />
          <IonApp>
            <IonReactRouter>
              <IonTabs>
                <IonRouterOutlet>
                  <Route
                    path="/player/:episode_id"
                    component={EpisodeTab}
                    exact
                  />
                  {/* <Route
                    path="/"
                    render={() => <Redirect to="/player" />}
                    exact
                  /> */}
                </IonRouterOutlet>
                <IonTabBar role="tablist" slot="bottom">
                  <IonTabButton tab="tab1" href="/player">
                    <IonIcon aria-hidden="true" icon={triangle} />
                    <IonLabel>Tab 1</IonLabel>
                  </IonTabButton>
                  {/* <IonTabButton tab="tab2" href="/tab2">
                    <IonIcon aria-hidden="true" icon={ellipse} />
                    <IonLabel>Tab 2</IonLabel>
                  </IonTabButton>
                  <IonTabButton tab="tab3" href="/tab3">
                    <IonIcon aria-hidden="true" icon={square} />
                    <IonLabel>Tab 3</IonLabel>
                  </IonTabButton> */}
                </IonTabBar>
              </IonTabs>
            </IonReactRouter>
          </IonApp>
        </GlobalStyles>
      </ChakraProvider>
    </QueryClientProvider>
  );
};

export default App;
